import React from "react";

const WBMAC = () => {
  return <div>WBMAC WBMAC</div>;
};

export default WBMAC;
